import { getStore } from '@/store';
import getters from './getters';
import actions from './actions';
import { getRecentlySearch } from '../_util';

// import { searchCenter } from './isSearchCenter';
function initState(searchCenter = true) {
    const common = {
        outsideFields: [],
        hiddenOutFields: [],
        conditions: {},
        keywords: [],
        recentlySearch: getRecentlySearch(),
        mapCondition: {},
        customizedCity: [],
        searchCharts: [],
        locationPlaceholder: '',
        listingIds: '',
        translatedProps: {}, // for recording search-bar among those select The dropdown list of the box has been translated ， like ：{propertyType: true}
        currencyPriceKeys: [] //  Store the search configuration inside with price related fields ， Need to convert to USD ,  Pass USD when searching
    };
    const state = {
        // fetcherData conditionSort  data redundancy
        fetcherData: {}, //  data for rendering ， Contains information such as grouping
        conditionSort: [], //  for tag sort of
        searchQueryOnUrl: null,
        hasConditionOnUrl: false,
        locationQueryOnUrl: '',
        urlPresetParams: null,
        mapConditionOnUrl: {
            rect: '',
            mapPath: '',
            mapSearch: false,
            zoom: 14,
            threshold: 10
        }
        // ...common
    };
    const centerState = {
        uiConfig: {},
        fetcherData: {}, //  data for rendering ， Contains information such as grouping
        conditionSort: [],
        // outsideFields: [],
        // searchConfigMap: {},
        computedPresetFilter: {},
        urlPresetParams: null,
        conditionOnUrl: {}
        // ...common
    };
    return () => ({
        ...common,
        ...(searchCenter ? centerState : state)
    });
}

export default function(pinia) {
    let { isSearchCenter } = getStore('page', pinia);
    return {
        state: initState(isSearchCenter),
        getters: getters(isSearchCenter),
        actions: actions(isSearchCenter)
    };
}
